import { AppMessages } from '../types';
import { pl } from './pl';

export const de: AppMessages = {
  ...pl,
  nav: { home: 'Startseite', study: 'Lernen', questionDemo: 'Fragenvorschau', exam: 'Prüfung' },
  userMenu: {
    settings: 'Einstellungen',
    status: 'Status',
    logout: 'Abmelden',
    anonymous: 'Nicht angemeldet',
    tierFree: 'Free',
    tierPremium: 'Premium',
    tierAdmin: 'Admin',
  },
  common: { loadingSession: 'Sitzung wird geprüft...', yes: 'Ja', no: 'Nein', days: 'Tage' },
  landing: {
    eyebrow: 'Alle Prüfungskategorien ab 0,16 PLN pro Tag',
    title: 'Bereite dich in einem Tempo auf den Führerschein vor, das wirklich beim Bestehen hilft.',
    description: 'Übe offizielle Fragen mit Videos und Bildern, lerne in kurzen Einheiten und prüfe deine Bereitschaft in einer Probeprüfung. Die Kategorien A, B, C, D, T und weitere sind an einem Ort verfügbar.',
    primaryCta: 'Lernen starten',
    secondaryCta: 'Probeprüfung ansehen',
    metricQuestions: 'Fragen aus dem Katalog',
    metricPriceValue: '0,16 PLN',
    metricPrice: 'pro Tag',
    metricCategoriesValue: 'voll',
    metricCategories: 'Kategorien abgedeckt',
    heroAlt: 'Fahrschüler löst online einen Führerscheintest',
    featureOneTitle: 'Du lernst, was Punkte bringt',
    featureOneText: 'Kurze Karteikarten-Einheiten helfen, Lücken schnell zu finden und Fragen erneut zu üben, die noch Aufmerksamkeit brauchen.',
    featureTwoTitle: 'Generalprobe vor der Prüfung',
    featureTwoText: 'Du löst Tests im Prüfungsaufbau, mit Bewertung, Ergebnisverlauf und Medien wie in der Fragendatenbank.',
    featureThreeTitle: 'Ein Konto für alle Kategorien',
    featureThreeText: 'Wähle deine Prüfungskategorie und trainiere den vollen Stoff für Motorrad, Pkw, Lkw oder Bus.',
    proofTitle: 'Starte kostenlos, voller Zugriff kostet nur wenige Groschen',
    proofText: 'Teste das Lernen ohne Risiko. Wenn du unbegrenzt üben möchtest, wähle Zugriff ab 0,16 PLN pro Tag. Alle Prüfungskategorien und die vollständige Fragenbasis sind enthalten.',
    profileCta: 'Zum Profil',
    createAccountCta: 'Konto erstellen',
  },
  home: {
    ...pl.home,
    title: 'Führerschein-Tests',
    signedIn: 'Angemeldet',
    username: 'Benutzername',
    email: 'E-Mail',
    noEmail: 'Keine E-Mail',
    providers: 'Anmeldeanbieter',
    emailVerified: 'E-Mail verifiziert',
    accountTier: 'Kontostatus',
    premiumUntil: 'Premium bis',
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    emailOrUsername: 'E-Mail oder Benutzername',
    password: 'Passwort',
    createAccount: 'Konto erstellen',
    pleaseWait: 'Bitte warten...',
    authenticationFailed: 'Anmeldung fehlgeschlagen.',
    or: 'oder',
    googleNotConfigured: 'Google-Anmeldung ist noch nicht konfiguriert.',
    googleFailed: 'Google-Anmeldung fehlgeschlagen.',
    googleLoadFailed: 'Google-Anmeldung konnte nicht geladen werden.',
    usernamePlaceholder: 'Benutzername',
    emailPlaceholder: 'E-Mail',
    resendVerificationTitle: 'Verifizierungs-E-Mail erneut senden',
    accountEmail: 'Konto-E-Mail',
    resendEmail: 'E-Mail erneut senden',
    sending: 'Senden...',
    resetPasswordTitle: 'Passwort per E-Mail zurücksetzen',
    sendResetEmail: 'Reset-E-Mail senden',
    changePasswordTitle: 'Passwort ändern',
    preferencesTitle: 'Lern- und Prüfungseinstellungen',
    savePreferences: 'Einstellungen speichern',
    preferencesSaved: 'Einstellungen wurden gespeichert.',
    preferencesFailed: 'Einstellungen konnten nicht gespeichert werden.',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    saving: 'Speichern...',
    changePassword: 'Passwort ändern',
    changePasswordFailed: 'Passwort konnte nicht geändert werden.',
    deleteAccountTitle: 'Konto löschen',
    deleteAccountHint: 'Gib zur Bestätigung deinen Benutzernamen ein. Lokale Konten benötigen zusätzlich das aktuelle Passwort.',
    usernameConfirmation: 'Benutzername bestätigen',
    deleteAccount: 'Konto löschen',
    deleting: 'Löschen...',
    deleteAccountFailed: 'Konto konnte nicht gelöscht werden.',
    activatePremiumCode: 'Premium-Code aktivieren',
    premiumCodePlaceholder: 'Premium-Code eingeben',
    redeemCode: 'Code aktivieren',
    redeeming: 'Aktivieren...',
    premiumActiveUntil: 'Premium aktiv bis',
    redeemFailed: 'Premium-Code konnte nicht aktiviert werden.',
    generatePremiumCodes: 'Premium-Codes generieren',
    generateCodes: 'Codes generieren',
    generating: 'Generieren...',
    generateFailed: 'Premium-Codes konnten nicht generiert werden.',
    alreadySignedInTitle: 'Du bist angemeldet',
    alreadySignedInText: 'Du kannst zum Lernen oder zu deinem Profil wechseln.',
    studyModeCta: 'Lernmodus',
    profileCta: 'Profil',
    backToHome: 'Startseite',
    signInTitle: 'Anmelden',
    createAccountTitle: 'Konto erstellen',
    authIntro: 'Ein Konto speichert Prüfungskategorie, Sprache, Lernfortschritt und Testverlauf.',
    loginTab: 'Anmeldung',
    registerTab: 'Registrierung',
    resendVerificationLink: 'Verifizierungslink erneut senden',
    forgotPassword: 'Passwort vergessen?',
    profileLoginTitle: 'Benutzerprofil',
    profileLoginText: 'Melde dich an, um Prüfungskategorie, Sprache, Konto und Premium-Status zu verwalten.',
    premiumActive: 'Premium aktiv bis',
    emailVerifiedShort: 'E-Mail verifiziert',
    emailUnverifiedShort: 'E-Mail nicht verifiziert',
    loginMethod: 'Anmeldung',
  },
  verifyEmail: {
    title: 'E-Mail verifizieren',
    verifying: 'E-Mail wird verifiziert...',
    incomplete: 'Der Verifizierungslink ist unvollständig.',
    failed: 'E-Mail konnte nicht verifiziert werden.',
    backToSignIn: 'Zur Anmeldung',
  },
  resetPassword: {
    title: 'Passwort zurücksetzen',
    incomplete: 'Der Reset-Link ist unvollständig.',
    failed: 'Passwort konnte nicht zurückgesetzt werden.',
    setNewPassword: 'Neues Passwort setzen',
    backToSignIn: 'Zur Anmeldung',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    text: 'Die eingegebene Adresse passt zu keinem Bildschirm dieser Anwendung. Gehe zur Startseite zurück oder öffne einen der verfügbaren Bereiche.',
  },
  questionDemo: {
    pageTitle: 'Fragenvorschau',
    pageDescription: 'Ziehe eine zufällige Prüfungsfrage und überprüfe die Antwort. Wähle den Bereich, um Grund- oder Spezialfragen zu üben.',
    loginRequired: 'Melde dich auf der Startseite an, um eine Frage aus dem Backend zu laden.',
    loading: 'Sitzung wird geprüft...',
    loadingCategories: 'Kategorien werden geladen...',
    loadQuestion: 'Andere Frage laden',
    loadingQuestion: 'Frage wird geladen...',
    languageLabel: 'Sprache',
    scopeLabel: 'Bereich',
    categoryLabel: 'Kategorie',
    scopeBasic: 'Grundwissen',
    scopeSpecialist: 'Spezialwissen',
    fetchErrorFallback: 'Die Frage konnte nicht geladen werden.',
    categoriesErrorFallback: 'Die Kategorien konnten nicht geladen werden.',
    publicPreviewNotice: 'Ohne Konto kannst du 10 Beispielfragen ansehen, die lokal in der App gespeichert sind. Wir laden sie nicht aus dem Backend.',
    publicPreviewLoading: 'Kostenlosen Satz mit 10 Fragen wird geladen...',
    publicPreviewSignupButton: 'Kostenloses Konto erstellen',
    signupModalTitle: 'Das ist das Ende der kostenlosen Vorschau',
    signupModalText: 'Melde dich an oder erstelle ein kostenloses Konto, um weiterzulernen und weitere Fragen freizuschalten.',
    signupModalCreateAccount: 'Kostenloses Konto erstellen',
    signupModalLogin: 'Ich habe bereits ein Konto',
    signupModalClose: 'Zurück zur Vorschau',
  },
  study: {
    title: 'Lernmodus',
    description: 'Wähle eine Prüfungskategorie und ein Thema. Die Fragen erscheinen als Karteikarten nach deinem Lernstand.',
    loginRequired: 'Melde dich auf der Startseite an, um zu lernen.',
    loading: 'Sitzung wird geprüft...',
    loadingCategories: 'Kategorien und Themen werden geladen...',
    languageLabel: 'Sprache',
    categoryLabel: 'Prüfungskategorie',
    tagLabel: 'Fragenthema',
    chooseScopeTitle: 'Lernbereich wählen',
    allTags: 'Alle Themen',
    start: 'Lernen starten',
    restart: 'Neu starten',
    loadingQuestions: 'Fragen werden geladen...',
    nextQuestion: 'Weiter',
    correct: 'Richtige Antwort',
    incorrect: 'Falsche Antwort',
    correctAnswer: 'Richtige Antwort',
    progressCorrect: 'richtig',
    progressNotCorrect: 'noch nicht',
    answered: 'Beantwortet',
    correctCount: 'Richtig',
    remaining: 'In der Warteschlange',
    noQuestionLoaded: 'Wähle eine Kategorie und starte das Lernen.',
    fetchErrorFallback: 'Die Lernfragen konnten nicht geladen werden.',
    categoriesErrorFallback: 'Kategorien oder Themen konnten nicht geladen werden.',
    submitErrorFallback: 'Der Lernstand konnte nicht gespeichert werden.',
    mediaUnavailable: 'Diese Frage hat keine Medien zur Anzeige.',
    adTitle: 'Kurze Werbepause',
    adText: 'Free-Nutzer sehen im Lernmodus nach jeweils 12 Fragen eine Werbung.',
    adContinue: 'Weiter lernen',
    adCountdown: 'Weiter in',
  },
  exam: {
    title: 'Probeprüfung',
    description: 'Nach dem Start wird der komplette Prüfungssatz für die gewählte Kategorie geladen. Eine Rückkehr zu früheren Fragen ist nicht möglich.',
    loginRequired: 'Melde dich auf der Startseite an, um die Prüfung zu starten.',
    loadingSession: 'Prüfung wird vorbereitet...',
    loadingCategories: 'Kategorien werden geladen...',
    languageLabel: 'Sprache',
    categoryLabel: 'Kategorie',
    startExam: 'Prüfung starten',
    startingExam: 'Fragen werden geladen...',
    nextQuestion: 'Nächste Frage',
    finishExam: 'Beenden und Ergebnis prüfen',
    questionCounter: 'Frage',
    globalTime: 'Gesamtzeit',
    answeredCount: 'Beantwortet',
    remainingCount: 'Verbleibend',
    resultTitle: 'Prüfungsergebnis',
    scoreLabel: 'Erreichte Punkte',
    maxScoreLabel: 'Maximale Punktzahl',
    passLabel: 'BESTANDEN',
    failLabel: 'NICHT BESTANDEN',
    passRule: 'Zum Bestehen sind mindestens 68 Punkte erforderlich.',
    fetchErrorFallback: 'Der Prüfungssatz konnte nicht geladen werden.',
    submitErrorFallback: 'Das Prüfungsergebnis konnte nicht geprüft werden.',
    submitInProgress: 'Ergebnis wird geprüft...',
    noExamLoaded: 'Wähle eine Kategorie und klicke auf Start, um den Prüfungssatz zu laden.',
    categoriesErrorFallback: 'Die Kategorien konnten nicht geladen werden.',
    resultAdTitle: 'Ergebnis nach der Werbung',
    resultAdText: 'Free-Nutzer sehen vor dem Prüfungsergebnis eine Werbung. Premium überspringt diesen Schritt.',
    resultAdCountdown: 'Ergebnis verfügbar in',
    resultAdContinue: 'Ergebnis anzeigen',
    resultAdPremiumCta: 'Premium kaufen',
    summaryTitle: 'Fragenübersicht',
    basicQuestionsTitle: 'Grundfragen',
    specialistQuestionsTitle: 'Spezialfragen',
    correctAnswer: 'Richtige Antwort',
    wrongAnswer: 'Falsche Antwort',
    userAnswer: 'Deine Antwort',
    expectedAnswer: 'Richtige Antwort',
    unanswered: 'Keine Antwort',
    testHistoryTitle: 'Testverlauf',
    noTestHistory: 'Keine gespeicherten Tests.',
  },
  ads: {
    googleSlotTitle: 'Google Ads Platz',
    wideSkyscraperText: 'Platzhalter für eine 160 x 600 Anzeige.',
    drivingOfferTitle: 'Fahrschulangebot',
    secondSlotText: 'Platzhalter für eine zweite 160 x 600 Anzeige.',
    roadSafetyTitle: 'Angebot zur Verkehrssicherheit',
    drivingSchoolTitle: 'Fahrschulwerbung',
    examResultTitle: 'Anzeige vor dem Ergebnis',
    mediumRectangleText: 'Platzhalter für eine 300 x 250 Anzeige.',
  },
  premium: {
    plansError: 'Pläne konnten nicht geladen werden. Aktualisiere die Seite.',
    checkoutError: 'Zahlung konnte nicht gestartet werden. Bitte versuche es erneut.',
    loading: 'Laden...',
    lead: 'Schalte vollen Zugriff auf Prüfungsverlauf, werbefreien Lernmodus und alle Fragenkategorien frei.',
    activeBadge: 'Du hast aktives Premium',
    activeUntil: 'bis',
    loadingPlans: 'Pläne werden geladen...',
    popular: 'Am beliebtesten',
    featureHistory: 'Vollständiger Prüfungsverlauf',
    featureNoAds: 'Lernen ohne Werbung',
    featureAllCategories: 'Alle Fragenkategorien',
    featureBestDailyPrice: 'Bester Tagespreis',
    redirecting: 'Weiterleitung...',
    buyNow: 'Jetzt kaufen',
    loginToBuy: 'Zum Kaufen anmelden',
    stripeHintPrefix: 'Zahlung abgewickelt über',
    stripeHintSuffix: 'Einmalige Zahlung - kein Abo.',
    successTitle: 'Zahlung abgeschlossen!',
    successText: 'Dein Konto wurde aktiviert. Premium ist jetzt aktiv.',
    successHint: 'Wenn Premium noch nicht im Konto sichtbar ist, aktualisiere die Seite gleich noch einmal - die Aktivierung dauert einige Sekunden.',
    backHome: 'Zur Startseite',
    cancelTitle: 'Zahlung abgebrochen',
    cancelText: 'Deine Karte wurde nicht belastet.',
    backToPlans: 'Zurück zu den Plänen',
  },
  scopeLabels: { PODSTAWOWY: 'Grundwissen', SPECJALISTYCZNY: 'Spezialwissen' },
  tagLabels: {
    'znaki-sygnaly': 'Verkehrszeichen und Signale',
    pierwszenstwo: 'Vorfahrt',
    manewry: 'Manöver und Richtungswechsel',
    ostroznosc: 'Vorsicht und Aufmerksamkeit',
    'predkosc-odstepy': 'Geschwindigkeit und Abstand',
    'piesi-rowerzysci': 'Fußgänger, Radfahrer und Übergänge',
    'skrzyzowania-pasy': 'Kreuzungen und Fahrstreifen',
    'parkowanie-zatrzymanie': 'Parken und Halten',
    'warunki-jazdy': 'Fahrbedingungen und Sicht',
    'stan-kierowcy': 'Fahrerzustand und Sicherheit',
    'pojazd-dokumenty': 'Fahrzeug, Ausrüstung und Dokumente',
    'transport-ladunek': 'Personen- und Gütertransport',
    inne: 'Sonstiges',
  },
};
